import { logPermissionDenied } from '@/services/audit/audit.service';
import type { AuditEntityType } from '@/types/audit';

const DEBOUNCE_MS = 60_000;
const STORAGE_PREFIX = 'erp:audit:denied:';

export function logPermissionDeniedDebounced(
  key: string,
  params: {
    entityType?: AuditEntityType;
    entityId?: string;
    metadata?: Record<string, unknown>;
  },
): void {
  if (typeof sessionStorage === 'undefined') {
    void logPermissionDenied(params);
    return;
  }

  const storageKey = `${STORAGE_PREFIX}${key}`;
  const last = sessionStorage.getItem(storageKey);
  const now = Date.now();
  if (last && now - Number(last) < DEBOUNCE_MS) return;

  sessionStorage.setItem(storageKey, String(now));
  void logPermissionDenied(params);
}
